import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  alpha,
  Skeleton,
} from "@mui/material";

const TableSkeleton = ({
  columns = [],
  actions = [],
  rows = 8,
  size = "small",
  showPagination = true,
}) => {
  const skeletonRows = Array.from({ length: rows });

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        borderRadius: "12px",
        border: "1px solid #F2F4F7",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.04)",
        background: "#FFFFFF",
        overflow: "hidden",
      }}
    >
      <Table size={size}>
        <TableHead>
          <TableRow sx={{ bgcolor: "#F8FAFC" }}>
            {columns.map((col) => (
              <TableCell
                key={col.field}
                sx={{
                  py: 1.5,
                  px: 1.5,
                  borderBottom: "1px solid #F2F4F7",
                }}
              >
                <Skeleton
                  variant="text"
                  width="70%"
                  height={16}
                  sx={{ bgcolor: alpha("#2469F0", 0.08) }}
                />
              </TableCell>
            ))}
            {actions?.length > 0 && (
              <TableCell
                align="center"
                sx={{
                  py: 1.5,
                  px: 1.5,
                  borderBottom: "1px solid #F2F4F7",
                }}
              >
                <Skeleton
                  variant="text"
                  width="60%"
                  height={16}
                  sx={{ bgcolor: alpha("#2469F0", 0.08), margin: "0 auto" }}
                />
              </TableCell>
            )}
          </TableRow>
        </TableHead>

        <TableBody>
          {skeletonRows.map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {columns.map((col, colIndex) => (
                <TableCell
                  key={col.field}
                  sx={{
                    py: 1.2,
                    px: 1.5,
                    borderBottom: "1px solid #F2F4F7",
                  }}
                >
                  <Skeleton
                    variant="text"
                    width={
                      colIndex === 0
                        ? "85%"
                        : colIndex % 3 === 0
                        ? "60%"
                        : "70%"
                    }
                    height={18}
                    sx={{ bgcolor: "#F2F4F7" }}
                  />
                </TableCell>
              ))}

              {actions?.length > 0 && (
                <TableCell
                  align="center"
                  sx={{
                    py: 1.2,
                    px: 1.5,
                    borderBottom: "1px solid #F2F4F7",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: 0.5,
                      justifyContent: "center",
                    }}
                  >
                    {actions.map((_, i) => (
                      <Skeleton
                        key={i}
                        variant="circular"
                        width={22}
                        height={22}
                        sx={{ bgcolor: "#F2F4F7" }}
                      />
                    ))}
                  </Box>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {showPagination && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            py: 1.5,
            bgcolor: "#FAFBFC",
            borderTop: "1px solid #F2F4F7",
          }}
        >
          <Skeleton variant="text" width={80} height={16} />
          <Box sx={{ display: "flex", gap: 0.5 }}>
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton
                key={i}
                variant="rounded"
                width={28}
                height={28}
                sx={{ borderRadius: "6px" }}
              />
            ))}
          </Box>
        </Box>
      )}
    </TableContainer>
  );
};

export default TableSkeleton;